import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_shipmentline_by_shipmentlineIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { shipmentlineId: number }): 
  Promise<{ result: { Id?: number, ExpectedAmount?: number, ExpectedPackagedAmount?: number, LineNumber?: number, OrderId?: number, OrderLineNumber?: number, ShipmentId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipmentlineId)) {
      $missingRequiredInParams.push('\'shipmentlineId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      shipmentlineId: number    }) {
        if(isNil($inParams.shipmentlineId)) {
          return true; 
        }
      return false;
    }
}
